// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"21cedbdd","239":"e39fb35b","268":"51517be6","312":"7a3d6fcb","640":"7ffd70eb","828":"6cc522b3"}[chunkId] + ".chunk.js";
};